import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { WrenchIcon, ZapIcon, ThermometerIcon, HomeIcon, PaintbrushIcon, SparklesIcon, TreesIcon, BugIcon, ShowerHeadIcon, BathIcon, ArrowUpIcon, SquareIcon, SunIcon, CookingPotIcon, LayersIcon, DoorOpenIcon, WarehouseIcon, ShieldIcon, FenceIcon, SnowflakeIcon, FootprintsIcon } from 'lucide-react';
interface PopularServicesProps {
  onServiceClick?: (serviceSlug: string) => void;
}
export function PopularServices({
  onServiceClick
}: PopularServicesProps) {
  const services = [{
    name: 'Walk-In Showers',
    slug: 'walk-in-showers',
    icon: <ShowerHeadIcon className="w-6 h-6" data-id="element-372" />
  }, {
    name: 'Walk-In Tubs',
    slug: 'walk-in-tubs',
    icon: <BathIcon className="w-6 h-6" data-id="element-373" />
  }, {
    name: 'Stairlifts',
    slug: 'stairlifts',
    icon: <ArrowUpIcon className="w-6 h-6" data-id="element-374" />
  }, {
    name: 'Window Replacement',
    slug: 'window-replacement',
    icon: <SquareIcon className="w-6 h-6" data-id="element-375" />
  }, {
    name: 'Gutter Guards',
    slug: 'gutter-guards',
    icon: <LayersIcon className="w-6 h-6" data-id="element-376" />
  }, {
    name: 'Roofing',
    slug: 'roofing',
    icon: <HomeIcon className="w-6 h-6" data-id="element-377" />
  }, {
    name: 'Siding',
    slug: 'siding',
    icon: <HomeIcon className="w-6 h-6" data-id="element-378" />
  }, {
    name: 'Solar Panels',
    slug: 'solar',
    icon: <SunIcon className="w-6 h-6" data-id="element-379" />
  }, {
    name: 'Bathroom Remodel',
    slug: 'bathroom-remodel',
    icon: <ShowerHeadIcon className="w-6 h-6" data-id="element-380" />
  }, {
    name: 'Kitchen Remodel',
    slug: 'kitchen-remodel',
    icon: <CookingPotIcon className="w-6 h-6" data-id="element-381" />
  }, {
    name: 'Flooring',
    slug: 'flooring',
    icon: <FootprintsIcon className="w-6 h-6" data-id="element-382" />
  }, {
    name: 'HVAC',
    slug: 'hvac',
    icon: <ThermometerIcon className="w-6 h-6" data-id="element-383" />
  }, {
    name: 'Painting',
    slug: 'painting',
    icon: <PaintbrushIcon className="w-6 h-6" data-id="element-384" />
  }, {
    name: 'Plumbing',
    slug: 'plumbing',
    icon: <WrenchIcon className="w-6 h-6" data-id="element-385" />
  }, {
    name: 'Electrical',
    slug: 'electrical',
    icon: <ZapIcon className="w-6 h-6" data-id="element-386" />
  }, {
    name: 'Fencing',
    slug: 'fencing',
    icon: <FenceIcon className="w-6 h-6" data-id="element-387" />
  }, {
    name: 'Insulation',
    slug: 'insulation',
    icon: <SnowflakeIcon className="w-6 h-6" data-id="element-388" />
  }, {
    name: 'Doors',
    slug: 'doors',
    icon: <DoorOpenIcon className="w-6 h-6" data-id="element-389" />
  }, {
    name: 'Garage Doors',
    slug: 'garage-doors',
    icon: <WarehouseIcon className="w-6 h-6" data-id="element-390" />
  }, {
    name: 'Home Security',
    slug: 'home-security',
    icon: <ShieldIcon className="w-6 h-6" data-id="element-391" />
  }, {
    name: 'Pest Control',
    slug: 'pest-control',
    icon: <BugIcon className="w-6 h-6" data-id="element-392" />
  }, {
    name: 'Landscaping',
    slug: 'landscaping',
    icon: <TreesIcon className="w-6 h-6" data-id="element-393" />
  }, {
    name: 'Cleaning',
    slug: 'cleaning',
    icon: <SparklesIcon className="w-6 h-6" data-id="element-394" />
  }, {
    name: 'General Repair',
    slug: 'general',
    icon: <WrenchIcon className="w-6 h-6" data-id="element-395" />
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      scale: 0.95,
      y: 10
    },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        duration: 0.4
      }
    }
  };
  return <section id="services" className="py-20 bg-slate-50" data-id="element-396">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-397">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4" data-id="element-398">
          <div data-id="element-399">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-400">
              Home Improvement Projects
            </h2>
            <p className="text-lg text-slate-600" data-id="element-401">
              Browse all of our service categories
            </p>
          </div>
        </div>

        <motion.div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} data-id="element-402">
          {services.map((service, index) => <motion.button key={index} variants={itemVariants} onClick={() => onServiceClick?.(service.slug)} className="group flex flex-col p-6 bg-white rounded-xl border border-slate-200 shadow-sm hover:shadow-md hover:border-amber-200 hover:-translate-y-1 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-amber-500 items-center justify-start cursor-pointer" data-id="element-403">
              <div className="w-12 h-12 rounded-lg text-slate-700 group-hover:bg-amber-50 group-hover:text-amber-600 flex items-center justify-center mb-4 transition-colors bg-[#F59E0B]" data-id="element-404">
                {service.icon}
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-405">
                {service.name}
              </h3>
              <span className="text-sm font-medium text-amber-500 opacity-0 group-hover:opacity-100 transition-opacity flex items-center gap-1" data-id="element-406">
                Get Quotes <span aria-hidden="true" data-id="element-407">&rarr;</span>
              </span>
            </motion.button>)}
        </motion.div>
      </div>
    </section>;
}